<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { usePollenStore } from '@/stores/pollen_store';
import AccountSettings from '@/views/Settings/AccountSettings.vue';
import DeviceList from '@/views/Settings/DeviceList.vue';
import ForgetSavedHosts from '@/views/Settings/ForgetSavedHosts.vue';
import Subscriptions from '@/views/Settings/Subscriptions.vue';

import Invoices from './Invoices.vue';

const pollenStore = usePollenStore();
const { computeProviderConfigs, isLocked } = storeToRefs(pollenStore);
</script>

<template>
  <div class="settings">
    <div class="settings__heading">Settings</div>

    <AccountSettings />
    <ForgetSavedHosts
      v-if="!isLocked && computeProviderConfigs"
      :saved-hosts="computeProviderConfigs"
    />

    <!-- TODO: we don't currently track devices anywhere. need some mechanism to report & manage them -->
    <DeviceList v-if="false" />

    <Subscriptions v-if="!isLocked" />

    <Invoices v-if="!isLocked" />
  </div>
</template>
<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/layout/grid-vars';
@use 'styles/core/typography/type';

.settings {
  &__heading {
    @include type.text--mono;

    margin-bottom: grid-vars.space(5);
    color: colors.color(grey);
  }
}
</style>
